<template>
  <div class="flex items-center gap-5 justify-center p-4">
    <img v-if="!isMobile" class="w-[120px] mt-[-100px] h-auto xl:w-[150px]" src="/images/voucher-left.png" alt="voucher-left"/>
    <img class="w-[330px] md:w-[400px] xl:w-[500px]" src="/images/title.png" alt="title-page"/>
    <img v-if="!isMobile" class="w-[180px] h-auto mt-[70px] xl:w-[200px]" src="/images/voucher-right.png" alt="voucher-right"/>
  </div>
</template>

<script>
export default {
  name: 'HeaderSpin',
  data() {
    return {
      isMobile: window.innerWidth < 767,
    }
  }
}
</script>